import { RegisterRepository } from '@/Account/domain/RegisterRepository'
import { RegisterIdentifyModel } from '@/Account/domain/RegisterModel'
import { HttpMethod, HttpModel, MetaStatusCodes } from '@/Shared/domain'
import { axiosFetch } from '@/Shared/infrastructure'
import {
  createAccount,
  registerEmailResend,
  registerVerifyIdentity,
  validateTokenAndGetMerchantData
} from '@/Shared/infrastructure/endpoints'
import { IndentifyForm, RegisterForm } from '../ui/hooks'
import { TokenResponseModel } from '../domain'

export function createRegisterRepository(): RegisterRepository {
  return new ApiRegisterRepository()
}

type createAccountRequest = {
  email: string
  emailRepeat: string
  userName: string
  password: string
  passwordRepeat: string
  name: string
  surName: string
  surName2?: string
  acceptConditions: boolean
  token?: string
}

type RegisterIdentifyApiForm = {
  backOfficeCompanyId: string
  legalId: string
}

export type ValidateTokenResponse = {
  accountCreationFrom?: number
  isNursery?: boolean
  userFirstname?: string
  userSurname1?: string
  userSurname2?: string
  email?: string
}

const convertFormToApi = (form: IndentifyForm): RegisterIdentifyApiForm => ({
  backOfficeCompanyId: form.backOfficeCompanyId,
  legalId: form.legalId,
})

const convertToRequest = (data: RegisterForm, token?: string): createAccountRequest => ({
  acceptConditions: data.acceptConditions,
  email: data.email,
  emailRepeat: data.emailRepeat,
  name: data.name,
  password: data.password,
  passwordRepeat: data.passwordRepeat,
  surName: data.surname1,
  surName2: data.surname2,
  userName: data.username,
  token: token
})

export class ApiRegisterRepository implements RegisterRepository {
  async VerifyIdentity(data: IndentifyForm): Promise<HttpModel<RegisterIdentifyModel>> {

    const response = await axiosFetch(registerVerifyIdentity, HttpMethod.POST, convertFormToApi(data))

    if (!response.data) {
      return {
        data: {} as RegisterIdentifyModel,
        meta: response.meta,
      }
    }

    return {
      data: response.data,
      meta: response.meta,
    }
  }

  async ResendEmail(data: IndentifyForm): Promise<HttpModel<string>> {
    return await axiosFetch(registerEmailResend, HttpMethod.POST, convertFormToApi(data))
  }

  async CreateAccount(data: RegisterForm, token?: string): Promise<HttpModel<TokenResponseModel>> {

    const response = await axiosFetch(createAccount, HttpMethod.POST, convertToRequest(data, token))

    if (!response.data) {
      return {
        data: {} as TokenResponseModel,
        meta: response.meta,
      }
    }

    return {
      data: response.data,
      meta: response.meta,
    }
  }

  async ValidateToken(token: string): Promise<HttpModel<ValidateTokenResponse>> {
    const response = await axiosFetch(validateTokenAndGetMerchantData + token, HttpMethod.GET, {})

    // Manejar cuando no hay respuesta (error de red)
    if (!response || !response.meta) {
      return {
        data: {} as ValidateTokenResponse,
        meta: {
          status: MetaStatusCodes.ERROR,
          messages: []
        },
      }
    }

    if (!response.data) {
      return {
        data: {} as ValidateTokenResponse,
        meta: response.meta,
      }
    }

    return {
      data: response.data,
      meta: response.meta,
    }
  }
}
